
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/airflow",
      function () {
        return require("private-next-pages/extensions/airflow.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/airflow"])
      });
    }
  